import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import Title from '@/components/_custom/Title/title.tsx'
import styles from './GlobalPlanningNotConfigured.module.scss'

interface GlobalPlanningNotConfiguredProps {
    daycareId: number
}

const GlobalPlanningNotConfigured: FunctionComponent<GlobalPlanningNotConfiguredProps> = ({
    daycareId
}: GlobalPlanningNotConfiguredProps) => {
    const { t } = useTranslation()
    const navigate: NavigateFunction = useNavigate()

    return (
        <div className={styles.TextContainer}>
            <div className={styles.Text}>
                <Title text={t('forUseGlobalPlanning')} />
                <p>
                    {t('youCanAddStaffRate')}
                    <span
                        className={styles.Link}
                        onClick={() => navigate(`/daycare?daycare=${daycareId}#staffSettings`)}
                    >
                        {t('clickHere')}
                    </span>
                </p>
            </div>
        </div>
    )
}

export default GlobalPlanningNotConfigured
